export default {
      id: "block_world_cave-usage",
      viewBox: "0 0 232.45 263.09",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#block_world_cave",
      toString: function () {
        return this.url;
      }
    }